import * as React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { NavigateFunction } from 'react-router-dom';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { withRouterV6 } from 'helpers/connectWithRouter';

const styles = require('./styles.pcss');

type Props = {
  id: any;
  cells: any;
  navigate: NavigateFunction;
};

const BookingsTableRow = ({ id, cells, navigate }: Props) => {

  return (
  <TableRow
    className={classNames(styles.clickable, styles.tableRow)}
    key={id}
    onClick={() => navigate(`/booking/${id}`)}
  >
    {cells.map((v: any, i: any) => {
      return (
        <TableCell
          className={classNames(styles.tableRowCell)}
          scope="row"
          key={`table-cell-${i}`}
        >
          {v}
        </TableCell>
      );
    })}
  </TableRow>
  )
};

export default withRouterV6(BookingsTableRow);
